import { productAvailability } from '@/checkoutForm/lib/constants';

export const isItemPreOrder = (item) => {
  return item?.availability === productAvailability.PreOrder;
};

export const isItemFunding = (item) => {
  return item?.availability === productAvailability.Funding;
};
